import _ from 'lodash'

/**
 * Стандартный Enum
 * Класс должен содержать static поля со значениями
 *
 * static KEY1 = 1
 * static KEY2 = 1
 * static KEY3 = 1
 */
export default class Enum {
  /**
   * Возвращает имя Enum класса. Используется при выводе ошибок.
   * constructor.name == Function
   */
  static get name () {
    throw new Error('abstract')
  }

  /**
   * Список значений
   * static KEY1 = 1
   * static KEY2 = 1
   * static KEY3 = 1
   */

  /**
   * Метод должен возвращать массив с именами полей-значений.
   * Позволяет сортировать итерирование.
   * ['KEY1', 'KEY2', 'KEY3']
   * @return {string[]}
   */
  static get keys () {
    throw new Error('abstract')
  }

  /**
   * Возвращает текстовое имя значения
   * @return {string}
   */
  static label (value) {
    throw new Error('abstract')
  }

  /**
   * Возвращает ключ по значению value
   * @param {*} value значение равное одному из item.value
   * @returns {string|undefined|*}
   */
  static keyOf (value) {
    return _.findKey(this, (val) => {
      return val === value
    })
  }

  /**
   * Преобразует в массив.
   * Используется в шаблонах vue (v-for пока не работает с iterable).
   */
  static toArray () {
    return [...this]
  }

  /**
   * Для итерирования
   */
  static [Symbol.iterator] () {
    return this
  }

  /**
   * Для итерирования.
   * Итератор возвращает значения. По ключам можно итерировать по свойству keys.
   */
  static next () {
    if (this.currIndex === undefined) {
      this.currIndex = -1
    }

    if (this.currIndex < (this.keys.length - 1)) {
      this.currIndex++

      return {
        done: false,
        value: this[this.keys[this.currIndex]]
      }
    } else {
      delete this.currIndex
      return {
        done: true
      }
    }
  }

  static throwWrongValueException (value) {
    throw new Error(`Wrong enum value "${value}" for enum "${this.name}"`)
  }
}



// WEBPACK FOOTER //
// ./dev-packages/Core/assets/Enum.js